export default "__VITE_ASSET__B$Du6lbD__"